import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=1605d630&scoped=true&"
import script from "./ChatContact.vue?vue&type=script&lang=js&"
export * from "./ChatContact.vue?vue&type=script&lang=js&"
import style0 from "./ChatContact.vue?vue&type=style&index=0&id=1605d630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605d630",
  null
  
)

export default component.exports